export default __webpack_public_path__ + "static/latency-mobile2-f3e859ef19fa9e907fa0fe24a29d55e7.png";